import menAndHorse from '../../assets/images/public/about-us-page/men-horse.jpg';
import girlAndHorse from '../../assets/images/public/about-us-page/girl-horse.jpg';
import oldMenAndHorse from '../../assets/images/public/about-us-page/old-men-horse.jpg';
import womenAndHorse from '../../assets/images/public/about-us-page/women-horse.jpg';
import supportVeterans from '../../assets/images/public/about-us-page/support-veterans.jpg';
import supportVolunteers from '../../assets/images/public/about-us-page/support-volunteers.jpg';
import supportChildren from '../../assets/images/public/about-us-page/support-children.jpg';
export const ABOUT_US_DATA = {
    OUR_VALUES: 'Наші Цінності',
    VALUE_ITEMS: [
        {
            NAME: 'Емпатія',
            DESCRIPTION:
                'Ми поділяємо почуття та емоції наших учасників/ць, і ставимось до емоційного' +
                ' стану ветеранів/ок та дітей із розумінням та повагою.',
        },
        {
            NAME: 'Розширення прав і можливостей',
            DESCRIPTION:
                'Прагнемо не лише бути поруч із учасниками/цями, але й безпосередньо сприяти їхньому' +
                ' відновленню та подальшому особистому розвитку.',
        },
        {
            NAME: 'Єдність',
            DESCRIPTION: 'Створюємо спільноту підтримки, турботи та довіри, адже разом ми сильніші.',
        },
        {
            NAME: 'Різноманіття',
            DESCRIPTION: 'Ми поважаємо та цінуємо унікальний досвід і життєвий шлях кожної людини, з якою взаємодіємо.',
        },
        {
            NAME: 'Стійкість',
            DESCRIPTION:
                'Віримо у силу духу людини, й щиро прагнемо підтримати кожного/у на його/її шляху подолання' +
                ' труднощів та зміцнення життєстійкості.',
        },
        {
            NAME: 'Відповідальність',
            DESCRIPTION:
                'Ми несемо відповідальність за наші дії та слова перед учасниками/цями, партнерами й благодійниками.',
        },
        {
            NAME: 'Партнерство',
            DESCRIPTION: 'Культивуємо партнерство і обмін досвідом на локальному, національному й міжнародному рівнях.',
        },
        {
            NAME: 'Інновації',
            DESCRIPTION:
                'Прагнемо до постійного пошуку та впровадження нових підходів до терапії та відновлення' +
                ' психічного здоров’я задля ефективної підтримки нашої спільноти.',
        },
        {
            NAME: 'Прозорість і чесність',
            DESCRIPTION:
                'Ми дотримуємось принципів відкритості, прозорості та етичності у нашій діяльності та за її межами.',
        },
    ],
    INTRO_TITLE: {
        FIRST_HIGHLIGHT: 'Простір',
        MIDDLE_PART: ' довіри, турботи та твоєї ',
        SECOND_HIGHLIGHT: 'внутрішньої сили',
    },
    INTRO_DETAILS: {
        FIRST_LINE: 'Victory Center — це не про терміни чи цифри. ',
        SECOND_LINE: 'Це про відчуття. Тут ти зупиняєшся в моменті, ',
        THIRD_LINE: 'де зникає напруга, і починається зцілення. ',
        FOURTH_LINE:
            'Через спільноту, природу й контакт із кіньми ти повертаєшся до себе справжнього/ої. ' +
            'Ми не змінюємо людей. Ми допомагаємо їм згадати, ',
        FIFTH_LINE: 'ким вони є.',
    },
    PEOPLE_DATA: [
        {
            IMG: menAndHorse,
            ALT: 'Men and horse',
            INFO: 'Учасники/ці, які вірять і довіряють',
            CARD_CLASS: 'aside-card',
        },
        {
            IMG: girlAndHorse,
            ALT: 'Girl and horse',
            INFO: 'Партнери, які поділяють наші мрії та цінності',
            CARD_CLASS: 'middle-card',
        },
        {
            IMG: oldMenAndHorse,
            ALT: 'Old men and horse',
            INFO: 'Волонтери/ки, які поруч, аби підтримати',
            CARD_CLASS: 'middle-card',
        },
        {
            IMG: womenAndHorse,
            ALT: 'Women and horse',
            INFO: 'Благодійники/ці, які допомагають втілити ідеї в реальність',
            CARD_CLASS: 'aside-card',
        },
    ],
    MAIN_VALUE: {
        FIRST_PART: 'Головна ',
        FIRST_HIGHLIGHT: 'цінність',
        MIDDLE_PART: ' Victory Center ',
        SECOND_HIGHLIGHT: 'це люди',
    },
    MAIN_VALUE_DETAILS: {
        FIRST_LINE: 'Ми віримо в силу спільноти, в якій кожен голос ',
        SECOND_LINE: 'важливий, а кожен крок - наближує до спільної ',
        THIRD_LINE: 'перемоги.',
    },
    SUPPORT_TITLE: 'Кого ми можемо підтримати',
    SUPPORT_DATA: [
        {
            IMG: supportVeterans,
            ALT: 'Підтримка ветеранів',
            DESCRIPTION:
                'Ветеранів/ок, що повернулися із фронту/полону та прагнуть відновити контакт із собою' +
                ', своїм тілом та близькими.',
        },
        {
            IMG: supportVolunteers,
            ALT: 'Підтримка волонтерів',
            DESCRIPTION:
                'Волонтерів/ок та цивільних, які відчувають потребу в емоційному відновленні і прагнуть' +
                ' продовжувати підтримувати інших.',
        },
        {
            IMG: supportChildren,
            ALT: 'Підтримка дітей',
            DESCRIPTION:
                'Дітей, що постраждали від війни та пройшли через втрату, страх, вимушений переїзд.' +
                ' Через ігрову терапію, взаємодію у групах та контакт із тваринами, ми допомагаємо сформувати' +
                ' довіру маленьких українців/ок до оточуючих та повернути відчуття безпеки.',
        },
    ],
    DONATE_TITLE: 'Ви завжди можете підтримати нас',
    DONATE_DETAILS: 'Оберіть той спосіб, який підходить вам найбільше',
    DONATE: 'Донатити',
    BECOME_PARTNER: 'Стати партнером',
    WHAT_WE_DO: 'Що ми робимо',
    WHAT_WE_DO_DETAILS:
        'Ми створюємо терапевтичні програми, які поєднують взаємодію ' +
        'з кіньми, тілесні практики, контакт із природою, психологічний ' +
        'супровід, спільноту підтримки. Кожна програма адаптується під ' +
        'індивідуальні запити учасників/ць групи.',
    GO_TO_PROGRAMS: 'Перейти до програм',
    GO_TO_TEAM: 'Переглянути команду',
    TEAM_DETAILS: {
        FIRST_PART:
            'Victory Center — це спільна робота психологів, фасилітаторів, ' +
            'координаторів, волонтерів, а також партнерських локацій (ранчо), об’єднаних ' +
            'прагненням створити безпечне середовище для відновлення.',
        SECOND_PART:
            'Наша команда працює з військовими/ветеранами, дітьми та їхніми родинами,' +
            ' проходить регулярне навчання, дотримується етичного кодексу, не знецінює, а цінує та підтримує',
    },
};
